import { render, staticRenderFns } from "./RenameUserNameModal.vue?vue&type=template&id=1c996e72&scoped=true"
import script from "./RenameUserNameModal.vue?vue&type=script&lang=js"
export * from "./RenameUserNameModal.vue?vue&type=script&lang=js"
import style0 from "./RenameUserNameModal.vue?vue&type=style&index=0&id=1c996e72&prod&scoped=true&lang=css"
import style1 from "./RenameUserNameModal.vue?vue&type=style&index=1&id=1c996e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c996e72",
  null
  
)

export default component.exports